import React, { useState } from "react";
import styles from "./FAQ.module.css"; // Import CSS Module

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null); // Track active FAQ item

  const toggleFAQ = (index) => {
    // Toggle active index (open/close)
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
        question: "Hoe kan ik beginnen met het gebruik van het platform?",
        answer:
        "Het is eenvoudig! Maak een account aan, voeg je restaurant of delicatessenzaak toe, en begin je menu’s en producten toe te voegen. Je hebt binnen een paar minuten je eigen webshop klaar om klanten te verwelkomen.",
    },
    {
        question: "Kan ik mijn webshop aanpassen aan de stijl van mijn restaurant?",
        answer:
        "Ja, absoluut! Je kunt de webshop volledig personaliseren, van kleuren tot logo en menu-indeling. Het is jouw online winkel, dus het moet jouw stijl weerspiegelen.",
    },
    {
        question: "Hoe werkt de betalingen en het afhaalsysteem?",
        answer:
          "Klanten kunnen eenvoudig via je webshop betalen. Ze kiezen een tijdslot voor het afhalen van hun bestelling, zodat alles soepel en zonder wachttijden verloopt.",
      },
      {
        question: "Wat als ik hulp nodig heb tijdens het opzetten?",
        answer:
          "Geen zorgen! Ons supportteam staat altijd klaar om je te helpen. We bieden zowel telefonische als e-mailondersteuning en hebben handige handleidingen en tutorials om je op weg te helpen.",
      },
      {
        question: "Hoe veilig zijn de betalingen op Resto-online?",
        answer:
          "De betalingen op Resto-online zijn volledig veilig. We maken gebruik van de nieuwste encryptietechnologieën om ervoor te zorgen dat alle transacties veilig en beschermd zijn.",
      },
      {
        question: "Biedt Resto-online ondersteuning voor meerdere talen?",
        answer:
          "Ja, Resto-online ondersteunt meerdere talen, zodat je klanten in hun voorkeurstaal kunnen bestellen. Dit maakt het gebruik van het platform toegankelijker voor een breder publiek.",
      },
      {
        question: "Waarom zou ik Resto-online gebruiken?",
        answer:
          "Resto-online maakt bestellen eenvoudig en intuïtief. Klanten bladeren moeiteloos door je menu en bestellen met één klik, wat vaak leidt tot extra keuzes, een hogere omzet en tevreden klanten.",
      },
  ];

  return (
    <div className={styles["parent-container"]}>
      <ul className={styles.faq}>
        {faqData.map((item, index) => (
          <li key={index} className={`${styles.listItem} ${activeIndex === index ? styles.active : ""} mobile-t-a-s`}>
            <h3 className={styles.question} onClick={() => toggleFAQ(index)}>
              {item.question}
              <div className={`${styles["plus-minus-toggle"]} ${activeIndex === index ? "" : styles.collapsed}`}></div>
            </h3>
            <div className={styles.answer} style={{maxHeight: activeIndex === index ? "275px" : "0", paddingBottom: activeIndex === index ? "25px" : "0",}}>
              {item.answer}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQ;
